import React from 'react';
import { Full } from '../../layout/Full/Full';
import { AbsoluteCenter } from '../../layout/AbsoluteCenter/AbsoluteCenter';
import { PanelLayout } from '../../layout/Panel/Panel';
import { Spacing } from '../../layout/Spacing/Spacing';
import { Redirect } from '../Redirect/Redirect';
import { useRedirect } from '../../../hooks/useRedirect';

interface IRedirectPageProps {
    children?: React.ReactNode;
    redirectTime: number;
    redirectRoute: string;
    title: string;
    isLoggedIn: boolean;
    custom?: boolean;
}

export const RedirectPage: React.FC<IRedirectPageProps> = ({ children, custom = false, redirectTime, redirectRoute, title, isLoggedIn }) => {
    const { count } = useRedirect(redirectTime, redirectRoute);

    return (
        <Full>
            <AbsoluteCenter size={40} top={20}>
                <PanelLayout>
                    <Spacing marginSpacing={'none'} paddingSpacing={'xl'}>
                        <Redirect count={count} title={title} isLoggedIn={isLoggedIn} navigateTo={redirectRoute} />
                    </Spacing>
                </PanelLayout>
            </AbsoluteCenter>
        </Full>
    );
};
